
import { Link } from "react-router-dom";
import { Session } from "@supabase/supabase-js";
import { useIsMobile } from "@/hooks/use-mobile";

export const NavigationLinks = ({ session }: { session: Session | null }) => {
  const isMobile = useIsMobile();

  return (
    <div className="flex items-center gap-4">
      <Link to="/" className={`font-bold ${isMobile ? 'text-lg' : 'text-xl'} text-primary`}>
        Everley Training
      </Link>
      {!isMobile && (
        <>
          <Link to="/" className="text-sm font-medium text-gray-600 hover:text-primary">
            Home
          </Link>
          {session && (
            <Link to="/training" className="text-sm font-medium text-gray-600 hover:text-primary">
              My Training Resources
            </Link>
          )}
        </>
      )}
    </div>
  );
};
